import Navbar from './components/Navbar';
import Footer from './components/Footer';
import './App.css';

function SummerCamps() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Title Section */}
      <div className="mt-16 md:mt-24 py-12 md:py-16 bg-white">
        <div className="max-w-[1200px] mx-auto px-4 md:px-6">
          <h1 className="text-4xl md:text-6xl text-center uppercase italic tracking-[0.2em] md:tracking-[0.3em] mb-6 md:mb-8 font-light">
            2026 SUMMER CAMPS
          </h1>

          <p className="text-center font-bold text-lg mb-4" style={{ color: '#F5A623' }}>
            For Bookings: <a href="mailto:bookings@throttledge.com" className="text-red-600 hover:underline">bookings@throttledge.com</a>
          </p>

          <div className="flex justify-center mb-16">
            <button className="border-2 border-black text-black px-12 py-3 hover:bg-black hover:text-white transition-colors uppercase text-sm font-bold tracking-widest">
              GIFT CERTIFICATES
            </button>
          </div>

          {/* Hero Image */}
          <div className="mb-12 md:mb-16">
            <img 
              src="/a4.webp" 
              alt="Summer Camps" 
              className="w-full h-[500px] object-cover"
            />
          </div>

          {/* Camp Cards - Three Columns */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 mb-12 md:mb-16">
            {/* Moto Kids Camp Card */}
            <div>
              <img 
                src="/a4.webp" 
                alt="Moto Kids Camp" 
                className="w-full h-64 object-cover mb-6"
              />
              <h2 className="text-3xl font-bold mb-6 uppercase italic tracking-wider" style={{ color: '#F5A623' }}>
                Moto Kids Camp (Age 6-16)
              </h2>
              <div className="space-y-2 text-gray-800 mb-6">
                <p><span className="font-semibold">2026 Dates:</span> July 7th - 10th & August 25th - 28th</p>
                <p className="text-sm italic">(Overnight option available for the August week)</p>
                <p><span className="font-semibold">Time:</span> 9:00am - 5:00pm daily</p>
                <p><span className="font-semibold">Bike Requirement:</span> Riders must bring their own bike</p>
                <p><span className="font-semibold">Price:</span> PKR 155,240 + HST</p>
              </div>
              
              <h3 className="text-2xl font-bold mb-4 uppercase italic tracking-wider" style={{ color: '#F5A623' }}>
                About the Camp
              </h3>
              <div className="space-y-4 text-gray-800 leading-relaxed text-sm mb-6">
                <p>
                  Moto Kids Camp at Throttle Edge is a 4-day dirt bike camp designed for young riders who want to ride more, learn more, and have an unforgettable summer adventure. This camp delivers the perfect mix of riding, learning, and classic camp fun.
                </p>
                <p>
                  Each day combines structured on-bike coaching with plenty of free ride time across our tracks and trails. Riders work closely with our experienced instructors to sharpen key skills—cornering, braking, jumping, throttle control, body position, track awareness, and more—while building confidence and having a blast.
                </p>
              </div>
              
              <h3 className="text-2xl font-bold mb-4 uppercase italic tracking-wider" style={{ color: '#F5A623' }}>
                What's Included
              </h3>
              <ul className="space-y-2 text-gray-800 text-sm mb-6">
                <li>• Daily lunch and hydration</li>
                <li>• Hands-on coaching from experienced instructors</li>
                <li>• Track & trail access throughout the week</li>
                <li>• Off-bike activities, games & outdoor fun</li>
                <li>• <span className="font-bold">NEW for 2026:</span> Optional Overnight Camp Week (August session only) Campers can stay on-site with supervised overnight accommodations, nighttime activities, and an elevated summer camp experience.</li>
              </ul>
              
              <div className="space-y-3">
                <button className="w-full border-2 border-black text-black px-6 py-3 hover:bg-black hover:text-white transition-colors uppercase text-xs font-bold tracking-widest">
                  BOOK JULY CAMP
                </button>
                <button className="w-full border-2 border-black text-black px-6 py-3 hover:bg-black hover:text-white transition-colors uppercase text-xs font-bold tracking-widest">
                  BOOK AUGUST CAMP
                </button>
              </div>
            </div>

            {/* Pre-Walton Camp Card */}
            <div>
              <img 
                src="/a1.jpg" 
                alt="Pre-Walton Camp" 
                className="w-full h-64 object-cover mb-6"
              />
              <h2 className="text-3xl font-bold mb-6 uppercase italic tracking-wider" style={{ color: '#F5A623' }}>
                Pre-Walton Motocross Camp
              </h2>
              <div className="space-y-2 text-gray-800 mb-6">
                <p><span className="font-semibold">2026 Dates:</span> July 28th - 31st, 2026</p>
                <p><span className="font-semibold">Time:</span> 9:00am - 5:00pm daily</p>
                <p><span className="font-semibold">Bike Requirement:</span> Riders must bring their own bike</p>
                <p><span className="font-semibold">Price:</span> PKR 165,590 + HST</p>
              </div>
              
              <h3 className="text-2xl font-bold mb-4 uppercase italic tracking-wider" style={{ color: '#F5A623' }}>
                About the Camp
              </h3>
              <div className="space-y-4 text-gray-800 leading-relaxed text-sm mb-6">
                <p>
                  Pre Walton Camp at Throttle Edge is a 4-day high-intensity training program designed specifically for racers gearing up for the Walton TransCan Amateur National. This camp is built for riders who are serious about progression, race preparation, and sharpening their skills under real-track conditions.
                </p>
                <p>
                  Throughout the week, riders receive focused instruction from the GDR race team who break down technique, analyze rider form, and push each athlete to ride stronger, smarter, and more confidently. Training includes advanced drills, race-pace motos, section work, line choice development, and bike setup guidance to help riders perform at their highest level.
                </p>
              </div>
              
              <h3 className="text-2xl font-bold mb-4 uppercase italic tracking-wider" style={{ color: '#F5A623' }}>
                What's Included
              </h3>
              <ul className="space-y-2 text-gray-800 text-sm mb-6">
                <li>• Daily lunch and hydration</li>
                <li>• High-level instruction from the GDR team</li>
                <li>• Race-pace motos & advanced technical drills</li>
                <li>• Track access for training & section work</li>
                <li>• Rider feedback, corrections & progression-focused coaching</li>
              </ul>
              
              <button className="w-full border-2 border-black text-black px-6 py-3 hover:bg-black hover:text-white transition-colors uppercase text-xs font-bold tracking-widest">
                BOOK CAMP
              </button>
            </div>

            {/* Red Rider Kids Camp Card */}
            <div>
              <img 
                src="/a9.webp" 
                alt="Red Rider Kids Camp" 
                className="w-full h-64 object-cover mb-6"
              />
              <h2 className="text-3xl font-bold mb-6 uppercase italic tracking-wider" style={{ color: '#F5A623' }}>
                Red Rider Kids Camp (Age 6-16)
              </h2>
              <div className="space-y-2 text-gray-800 mb-6">
                <p><span className="font-semibold">2026 Dates:</span> July 14th - 17th & August 11th - 14th</p>
                <p><span className="font-semibold">Time:</span> 9:00am - 5:00pm daily</p>
                <p><span className="font-semibold">Price:</span> PKR 247,365 + HST</p>
              </div>
              
              <h3 className="text-2xl font-bold mb-4 uppercase italic tracking-wider" style={{ color: '#F5A623' }}>
                About the Camp
              </h3>
              <div className="space-y-4 text-gray-800 leading-relaxed text-sm mb-6">
                <p>
                  No bike? No problem! The Red Rider Kids Camp is the ultimate beginner-friendly motocross experience for kids who want to learn how to ride in a safe, supportive, and super fun environment.
                </p>
                <p>
                  This 4-day camp is perfect for kids who love the outdoors and want to try something new and exciting. Campers are introduced to dirt biking through hands-on instruction from our experienced team, while also enjoying a variety of classic summer camp activities - outdoor games, team challenges, nature time, creative activities, and plenty of opportunities to make new friends.
                </p>
              </div>
              
              <h3 className="text-2xl font-bold mb-4 uppercase italic tracking-wider" style={{ color: '#F5A623' }}>
                What's Included
              </h3>
              <ul className="space-y-2 text-gray-800 text-sm mb-6">
                <li>• A Honda dirt bike for each camper</li>
                <li>• Full safety gear (helmet, boots, gloves, jersey, pants, etc.)</li>
                <li>• Riding instruction tailored to beginner skill levels</li>
                <li>• Daily lunch and hydration</li>
                <li>• Access to beginner-friendly tracks & outdoor riding areas</li>
              </ul>
              
              <div className="space-y-3">
                <button className="w-full border-2 border-black text-black px-6 py-3 hover:bg-black hover:text-white transition-colors uppercase text-xs font-bold tracking-widest">
                  BOOK JULY CAMP
                </button>
                <button className="w-full border-2 border-black text-black px-6 py-3 hover:bg-black hover:text-white transition-colors uppercase text-xs font-bold tracking-widest">
                  BOOK AUGUST CAMP
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default SummerCamps;
